import {
    isEmailAddressValid, isPostalCodeValid,
    isPhoneValid, isValidUserName, isPasswordStrong,
    containsAlphaNumOnly, validAddress, containsAlphaNumAndSpaceOnly, containsAlphaNumAndSpaceAndPunctuationOnly
} from "../../util/Validators";

export const validateInput = (name, value, formData) => {
    let hasError = false,
        error = ""
    switch (name) {
        case "userName":
            if (value.trim() === "") {
                hasError = true
                error = "User name cannot be empty"
            } else if (!isValidUserName(value)) {
                hasError = true
                error = "Invalid Username."
            } else if (value.length < 5) {
                hasError = true
                error = "Username must be greater than 7 characters"
            }
            else {
                hasError = false
                error = ""
            }
            break
        case "password":
            if (value.trim() === "") {
                hasError = true
                error = "Password name cannot be empty"
            } else if (!isPasswordStrong(value)) {
                hasError = true
                error = "Password is not strong. It requires atleast one upper-case, one lower case, one numeric and one special character and cannot be less than eight characters.  "
            } else if (value.length < 8) {
                hasError = true
                error = "Username must be greater than 7 characters"
            }
            else {
                hasError = false
                error = ""
            }
            break
        case "firstName":
            if (value.trim() === "") {
                hasError = true
                error = "First name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid First Name. Only alpha-numeric characters are allowed"
            } else {
                hasError = false
                error = ""
            }
            break
        case "lastName":
            if (value.trim() === "") {
                hasError = true
                error = "Last name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid Last Name. Only alpha-numeric characters are allowed"
            } else {
                hasError = false
                error = ""
            }
            break
        case "companyName":
            if (value.trim() === "") {
                hasError = false
                error = ""
            } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                hasError = true
                error = "Invalid Company Name. Only alpha-numeric characters are allowed"
            } else {
                hasError = false
                error = ""
            }
            break
        case "address":
            if (value.trim() === "") {
                hasError = true
                error = "Address name cannot be empty"
            } else if (!validAddress(value)) {
                hasError = true
                error = "Invalid Address."
            } else {
                hasError = false
                error = ""
            }
            break
        case "city":
            if (value.trim() === "") {
                hasError = true
                error = "City name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid City. Only alpha-numeric characters are allowed."
            } else {
                hasError = false
                error = ""
            }
            break
        case "state":
            if (value.trim() === "") {
                hasError = true
                error = "State name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid State. Only alpha-numeric characters are allowed."
            } else {
                hasError = false
                error = ""
            }
            break
        case "country":
            if (value.trim() === "") {
                hasError = true
                error = "Country name cannot be empty"
            } else if (!containsAlphaNumOnly(value)) {
                hasError = true
                error = "Invalid Country. Avoid Special characters"
            } else {
                hasError = false
                error = ""
            }
            break
        case "email":
            if (value.trim() === "") {
                hasError = true
                error = "Email cannot be empty"
            } else if (!isEmailAddressValid(value)) {
                hasError = true
                error = "Invalid Email"
            } else {
                hasError = false
                error = ""
            }
            break
        case "mobilePhoneNumber":
            if (value.trim() === "") {
                hasError = true
                error = "Mobile cannot be empty"
            } else if (!isPhoneValid(value)) {
                hasError = true
                error = "Invalid Mobile Number. Use 10 digits only"
            } else {
                hasError = false
                error = ""
            }
            break
        case "officePhoneNumber":
            if (value.trim() === "") {
                hasError = false
            } else if (!isPhoneValid(value)) {
                hasError = true
                error = "Invalid Office Number. Use 10 digits only"
            } else {
                hasError = false
                error = ""
            }
            break
        case "zip":
            if (value.trim() === "") {
                hasError = true
                error = "Postal Code cannot be empty"
            } else if (!isPostalCodeValid(value, formData.country)) {
                hasError = true
                error = "Invalid Postal Code"
            } else {
                hasError = false
                error = ""
            }
            break
        default:
            break
    }
    return { hasError, error }
}